import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js";
import Util from "../utils/utils.js"
import * as tus from "tus-js-client"
import axios from 'axios'

class UnityVRButton {
  static createButton(manager) {
    const button = document.createElement("button");

    function showEnterVR(/*device*/) {

      button.style.display = "";

      button.style.cursor = "pointer";
      button.style.left = "calc(50%)";
      button.style.width = "150px";

      button.textContent = "ENTER UNITY VR";

      button.onmouseenter = function () {
        button.style.opacity = "1.0";
      };

      button.onmouseleave = function () {
        button.style.opacity = "0.5";
      };

      button.addEventListener("click",async()=>{
        button.innerText="正在Unity中创建场景...";
        console.log(manager);

        //await saveUnityScene();
        console.log("数据传递完成",window.base);
        //window.location.href="myvrapp://open?scene=SceneVR";
        let unityModelUrl=window.base+"/public/drawing/"+manager.options.assetid+"/scene_unity.glb"
        window.location.href="myvrapp://open?scene="+unityModelUrl;
      })
    }

    async function saveUnityScene() {
      console.log("saving unity scene");
      await new Promise((resolve, reject) => {
        const gltfExporter=new GLTFExporter();
        const gltfOptions = {
          trs: false, //是否只有translate，scale，rotate而没有matrix
          onlyVisible: false, //是否导出隐藏的模型
          binary: true, //是否导出二进制格式
          embedImages: true, //是否将贴图内嵌到模型
          animations: [],
        };

        gltfExporter.parse(
          manager.sceneManager.singleModels,
          async (result) => {
            let blob;
            let gltf = result;

            if (gltf instanceof ArrayBuffer) {
              blob = Util.saveArrayBuffer(gltf);
            } else {
              const output = JSON.stringify(gltf, null, 2);
              blob = Util.saveString(output);
            }

            const name = "scene" + (gltfOptions.binary ? ".glb" : ".gltf");
            const modelData = {
              blob,
              name
            };
            //if (!gltfOptions.embedImages) modelData.mapName = result.mapName;

            // 下载
            //Util.download(modelData.blob, modelData.name);

            console.log(manager.options.assetid)
            //向服务器上传场景模型
            const fd=new FormData()
            fd.append('unityModel', blob, "scene_unity.glb")
            fd.append('modelId', manager.options.assetid)

            await axios
            .post(window.base+'/drawing/uploadUnity',fd,{
              onUploadProgress: event => {
              }
            })
            .then(res => {

            })
            .catch(e => {
            })

            /*const upload=new tus.Upload(blob, {
              endpoint: window.base+"/drawing/uploadUnity",
              metadata:{
                filename:"scene_unity.glb",
                filetype:"model/gltf-binary"
              },
              onError:(err)=>{

                console.error(err);
                alert("上传失败，请重试");
              },
              onProgress:(bytesUploaded, bytesTotal)=>{
                console.log(bytesUploaded, bytesTotal)
              },
              
              onSuccess:()=>{
                console.log("上传成功");
                alert("上传成功");
              }
            });

            upload.start();*/

            resolve(modelData);

          },
          (error) => {
            console.error("GLTF导出错误:", error);
          },
          gltfOptions
        );
      })
    }

    function stylizeElement(element) {
      element.style.position = "absolute";
      element.style.top = "20px";
      element.style.padding = "12px 6px";
      element.style.border = "1px solid #fff";
      element.style.borderRadius = "4px";
      element.style.background = "rgba(0,0,0,0.1)";
      element.style.color = "#fff";
      element.style.font = "normal 13px sans-serif";
      element.style.textAlign = "center";
      element.style.opacity = "0.5";
      element.style.outline = "none";
      element.style.zIndex = "999";
    }

    showEnterVR();
    stylizeElement(button);

    return button;

  }
}

export { UnityVRButton };
